import parse from 'html-react-parser'
import Image from 'next/image'
import styles from './styles/partners.module.css'

const Partners = ({ partnerText, partnerImages, partnerImagesBox2, partnerImagesBox3, theme }) => (
  <div className={styles.partnerBoxDiv}>
    <div className={styles.partnerLogoDiv}>
      <div className={styles.headerLogo}>
        {partnerImages?.data?.map(item => (
            <div key={item.id} width={100} height={100} className={`${styles.headerImage} ${styles[theme]}`}>
              <Image
                className={styles.partnersLOGO}
                width={1000}
                quality={100}
                height={1000}
                unoptimized
                src={`${item?.attributes?.url}`}
                alt="Partner Amazon"
              />
            </div>
          ))}
      </div>
      <div className={styles.otherLogo}>
        {partnerImagesBox2?.data?.map(item => (
            <div key={item.id} width={100} height={100} className={`${styles.headerImage} ${styles[theme]}`}>
              <Image
                className={styles.partnersLOGO2}
                width={1000}
                height={1000}
                unoptimized
                src={`${item?.attributes?.url}`}
                alt="Partner Amazon"
              />
            </div>
          ))}
      </div>
      <div className={styles.otherLogo}>
        {partnerImagesBox3?.data?.map(item => (
            <div key={item.id} className={`${styles.headerImage} ${styles[theme]}`}>
              <Image
                className={styles.partnersLOGO2}
                width={100}
                height={100}
                unoptimized
                src={`${item?.attributes?.url}`}
                alt="Partner LOGO"
              />
            </div>
          ))}
      </div>
    </div>
    {parse(partnerText)}
  </div>
)
export default Partners
